var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("\n    TCD Web Design ©2019 by Youquan Yu\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }